export default "/images/vendor/flag-icon-css/flags/4x3/mo.svg?91c9cf0cfcb88dceaa1657739e8c03ff";